import { render, staticRenderFns } from "./DropdownOptionsEditor.vue?vue&type=template&id=3630b3c9"
import script from "./DropdownOptionsEditor.vue?vue&type=script&lang=js"
export * from "./DropdownOptionsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports